import { createContext } from 'react';

export const YsocialContext  = createContext<any>({});